// Contenu du README converti en HTML avec ancres pour la navigation
const readmeContent = `
<div id="readme-top">
<h1>Maquettes - Refactoring Module EP (Loi Plein Emploi)</h1>

<h2>📋 Vue d'ensemble</h2>
<p>Ce dossier contient les maquettes HTML des interfaces à développer pour l'adaptation du module d'Équipe Pluridisciplinaire (EP) selon la loi Plein Emploi.</p>
<p><strong>Saison :</strong> Adaptation EP loi Plein Emploi<br>
<strong>Objectif :</strong> Refactoring du module d'Équipe Pluridisciplinaire pour gérer les nouvelles modalités de sanctions des allocataires RSA</p>

<hr>

<div id="readme-inscription">
<h2>📁 1. Inscription d'un allocataire en EP</h2>
<p><strong>Fichier :</strong> <code>01-inscription-ep.html</code></p>
<p><strong>Contexte :</strong> Depuis la page de détail d'un allocataire dans le backoffice<br>
<strong>Rôle utilisateur :</strong> Référent Unique (RU) ou utilisateur avec droits d'inscription<br>
<strong>Cartes Jira concernées :</strong> CE-1143, CE-1149, CE-1133, CE-1142, CE-1135</p>

<h3>Fonctionnalités principales</h3>

<h4>Affichage des antécédents EP (CE-1135) - 2 niveaux d'information</h4>
<p><strong>Niveau 1 : Historique des EP</strong> (affiché en permanence)</p>
<ul>
  <li>Liste chronologique des EP précédentes</li>
  <li>Date de l'EP et date de notification</li>
  <li>Type de sanction et motif principal</li>
  <li>Permet au RU de voir le contexte global</li>
</ul>

<p><strong>Niveau 2 : Détection dynamique</strong> (apparaît après sélection du motif)</p>
<ul>
  <li><strong>Réitération détectée</strong> (fond rouge, bordure rouge) :
    <ul>
      <li>Même manquement &lt; 24 mois (à compter de la date de notification)</li>
      <li>Affichage du motif correspondant et de la date de l'EP précédente</li>
      <li>Message d'alerte explicite</li>
    </ul>
  </li>
  <li><strong>Persistance détectée</strong> (fond orange, bordure orange) :
    <ul>
      <li>Cumul de manquements différents</li>
      <li>Affichage du nombre d'EP antérieures</li>
      <li>Message d'information</li>
    </ul>
  </li>
  <li><strong>Premier manquement</strong> (fond bleu, bordure bleue) :
    <ul>
      <li>Aucun antécédent depuis le 01/06/2025</li>
      <li>Message de confirmation</li>
    </ul>
  </li>
</ul>

<p>Cette détection en temps réel permet au RU de comprendre immédiatement si la nouvelle inscription constitue une réitération ou une persistance par rapport aux motifs actuellement saisis.</p>

<h4>Autres fonctionnalités</h4>
<ul>
  <li><strong>Sélection de l'organisme de saisine</strong> (CAF, CCAS, PLIE, etc.)
    <ul><li>Suppression de "ML (seul)" et "CAF EG" (CE-1136)</li></ul>
  </li>
  <li><strong>Confirmation du contradictoire de 10 jours</strong> (obligatoire)
    <ul><li>Case à cocher obligatoire pour valider l'inscription</li></ul>
  </li>
  <li><strong>Choix du type de sanction</strong>
    <ul>
      <li>Suspension</li>
      <li>Suppression (permet un motif supplémentaire)</li>
    </ul>
  </li>
  <li><strong>Sélection des motifs</strong>
    <ul>
      <li><strong>Motif 1 (principal)</strong> :
        <ul>
          <li>"Refus d'élaborer ou d'actualiser le contrat" (SDD uniquement)</li>
          <li>"Non-respect des dispositions au contrat" (SDD uniquement)</li>
          <li>"Refus d'offre raisonnable d'emploi" (SDD uniquement, non valable pour parcours social)</li>
          <li>"Refus de se soumettre aux contrôles" (Suppression uniquement)</li>
        </ul>
      </li>
      <li><strong>Motif 2 (secondaires, optionnels)</strong> : peuvent modifier le barème proposé</li>
    </ul>
  </li>
  <li><strong>Proposition de barème automatique</strong>
    <ul>
      <li>Calculée par l'API selon les motifs et antécédents</li>
      <li>Le RU peut choisir parmi plusieurs options (couple durée/pourcentage)</li>
      <li>Cette proposition sera visible lors de la session EP</li>
    </ul>
  </li>
  <li><strong>Alerte âge</strong>
    <ul>
      <li>Affichage d'une alerte visuelle si l'allocataire a plus de 62 ans</li>
      <li>Les + de 62 ans ne doivent pas être sanctionnés</li>
    </ul>
  </li>
</ul>
</div>

<hr>

<div id="readme-liste-session">
<h2>📁 2. Liste des allocataires en session EP</h2>
<p><strong>Fichier :</strong> <code>02-liste-session-ep.html</code></p>
<p><strong>Contexte :</strong> Page de session EP, accessible depuis le calendrier des EP<br>
<strong>Rôle utilisateur :</strong> Président de séance<br>
<strong>Cartes Jira concernées :</strong> CE-1141, CE-1140, CE-1138, CE-1142</p>

<h3>Fonctionnalités principales</h3>
<ul>
  <li><strong>Informations de session</strong>
    <ul>
      <li>Date, secteur, président, secrétaire</li>
      <li>Statistiques : total allocataires, décisions prises, types de sanctions</li>
    </ul>
  </li>
  <li><strong>Liste des allocataires avec colonnes</strong>
    <ul>
      <li>Allocataire (nom, NIR, présence)</li>
      <li>Type de sanction (badge Suspension/Suppression)</li>
      <li>Motif principal</li>
      <li><strong>Avis de l'EP</strong> (nouvelle colonne enrichie) :
        <ul>
          <li>Proposition du RU (visible directement)</li>
          <li>Décision finale (si prise)</li>
          <li><strong>Radiation DE</strong> : Si la case "Radiation de la liste des demandeurs d'emploi" a été cochée, affichage d'un badge jaune "⚠️ Radiation DE pour la même durée"</li>
          <li><strong>Antécédents EP</strong> (affichés directement, CE-1141)</li>
        </ul>
      </li>
    </ul>
  </li>
  <li><strong>Indicateurs de présence</strong>
    <ul>
      <li>Présent (vert)</li>
      <li>Absent (rouge)</li>
      <li>Non renseigné (gris)</li>
    </ul>
  </li>
  <li><strong>Affichage des antécédents</strong> (CE-1140)
    <ul>
      <li>Visibles directement dans la liste</li>
      <li>Pas besoin d'ouvrir le détail de chaque ligne</li>
      <li>Indication de "Réitération" ou "Persistance" si détectée</li>
    </ul>
  </li>
  <li><strong>Alerte visuelle pour les + de 62 ans</strong> (CE-1142)
    <ul>
      <li>Ligne surlignée en jaune</li>
      <li>Badge clignotant "⚠️ 64 ANS"</li>
      <li>Message d'avertissement</li>
    </ul>
  </li>
  <li><strong>Validation en masse</strong> (CE-1138)
    <ul>
      <li>Cases à cocher pour sélectionner plusieurs allocataires</li>
      <li>Bouton "Valider les propositions sélectionnées"</li>
      <li>Permet d'accepter en masse les propositions du RU</li>
      <li>Gain de temps lors de la session</li>
    </ul>
  </li>
  <li><strong>Finalisation de session</strong>
    <ul>
      <li>Bouton "Finaliser la session" une fois toutes les décisions prises</li>
      <li>Transmission au directeur pour validation</li>
    </ul>
  </li>
</ul>
</div>

<hr>

<div id="readme-formulaire-decision">
<h2>📁 3. Formulaire de décision</h2>
<p><strong>Fichier :</strong> <code>03-formulaire-decision-ep.html</code></p>
<p><strong>Contexte :</strong> Modal/page ouverte depuis la liste de session EP<br>
<strong>Rôle utilisateur :</strong> Président de séance<br>
<strong>Cartes Jira concernées :</strong> CE-1149, CE-1141, CE-1135</p>

<h3>Fonctionnalités principales</h3>
<ul>
  <li><strong>Informations allocataire</strong>
    <ul><li>Identité complète, âge, statut, présence</li></ul>
  </li>
  <li><strong>Contexte de l'inscription</strong>
    <ul>
      <li>Type de sanction</li>
      <li>Motifs (principal + secondaires)</li>
      <li>Organisme de saisine</li>
    </ul>
  </li>
  <li><strong>Détection pour la session en cours</strong> (CE-1135)
    <ul>
      <li><strong>Section dédiée très visible</strong> (fond rouge ou orange selon le cas)</li>
      <li>Affichage de la réitération ou persistance <strong>pour cette session</strong></li>
      <li>Message explicite avec référence à l'EP concernée</li>
      <li>Permet au président de comprendre immédiatement la gravité de la situation</li>
    </ul>
  </li>
  <li><strong>Antécédents détaillés</strong> (CE-1135)
    <ul>
      <li>Liste complète des EP précédentes (historique)</li>
      <li>Chaque EP affiche son badge de détection passé :
        <ul>
          <li>🔴 Réitération (si c'était une réitération à l'époque)</li>
          <li>🟠 Persistance (si c'était une persistance à l'époque)</li>
          <li>ℹ️ Premier manquement (si c'était un premier manquement)</li>
        </ul>
      </li>
      <li>Date de l'EP et date de notification</li>
      <li>Le compteur des manquements commence au 1er juin 2025</li>
      <li>Permet de voir l'escalade du comportement de l'allocataire</li>
    </ul>
  </li>
  <li><strong>Proposition du RU</strong>
    <ul>
      <li>Affichée en référence</li>
      <li>Rappel que cette proposition a été calculée automatiquement</li>
    </ul>
  </li>
  <li><strong>Saisie de la présence</strong>
    <ul>
      <li>Présent</li>
      <li>Présent, accompagné(e)</li>
      <li>Absent</li>
      <li>Absent, observations écrites</li>
    </ul>
  </li>
  <li><strong>Décision de l'EP</strong> (CE-1149)
    <ul>
      <li><strong>Module de sélection de sanction</strong> avec algorithme</li>
      <li>Options calculées par l'API (couples durée/pourcentage)</li>
      <li>Possibilité de conserver la proposition du RU</li>
      <li>Possibilité de choisir une alternative</li>
      <li>Le président peut modifier la proposition du RU</li>
    </ul>
  </li>
  <li><strong>Options spécifiques en commission</strong>
    <ul>
      <li><strong>Si type Suppression</strong> :
        <ul><li>Case "Radiation de la liste des BRSA, sauf si mise en conformité" (cochée et indécochable)</li></ul>
      </li>
      <li><strong>Si type Suspension ou Suppression</strong> :
        <ul><li>Case "Radiation de la liste des demandeurs d'emploi" (cochable, uniquement sur les 3 premiers motifs)</li></ul>
      </li>
    </ul>
  </li>
  <li><strong>Note interne</strong>
    <ul><li>Champ texte libre pour commentaires</li></ul>
  </li>
</ul>
</div>

<hr>

<div id="readme-validation-directeur">
<h2>📁 4. Validation par le directeur</h2>
<p><strong>Fichier :</strong> <code>04-validation-directeur.html</code></p>
<p><strong>Contexte :</strong> Même page de session EP, mais vue directeur après finalisation<br>
<strong>Rôle utilisateur :</strong> Directeur (ou équivalent)<br>
<strong>Cartes Jira concernées :</strong> CE-1139, CE-1151</p>

<h3>Fonctionnalités principales</h3>
<ul>
  <li><strong>Informations de session</strong>
    <ul>
      <li>Mêmes infos que la vue président</li>
      <li>Indication "Session finalisée le [date]"</li>
    </ul>
  </li>
  <li><strong>Statistiques de validation</strong>
    <ul>
      <li>Total allocataires</li>
      <li>Validations effectuées</li>
      <li>Accords donnés</li>
      <li>Mises à sursoir</li>
      <li>En attente</li>
    </ul>
  </li>
  <li><strong>Liste des allocataires avec décisions</strong>
    <ul>
      <li>Allocataire</li>
      <li>Type de sanction</li>
      <li>Décision de l'EP (prise par le président)</li>
      <li><strong>Validation directeur</strong> (nouvelle colonne) :
        <ul>
          <li>En attente</li>
          <li>Accord donné</li>
          <li>À surseoir (avec commentaire)</li>
        </ul>
      </li>
    </ul>
  </li>
  <li><strong>Validation en masse</strong> (CE-1139)
    <ul>
      <li>Cases à cocher pour sélectionner plusieurs allocataires</li>
      <li>Bouton "Donner l'accord pour la sélection"</li>
      <li>Bouton "Mettre à sursoir la sélection"</li>
      <li>Gain de temps lors de la finalisation EP</li>
    </ul>
  </li>
  <li><strong>Actions individuelles</strong>
    <ul>
      <li>Voir le détail</li>
      <li>Donner l'accord</li>
      <li>Mettre à sursoir (avec commentaire obligatoire)</li>
      <li>Modifier une validation déjà effectuée</li>
    </ul>
  </li>
  <li><strong>Clôture de l'EP</strong>
    <ul>
      <li>Bouton "Clôturer l'EP et générer le PV"</li>
      <li>Activé uniquement quand toutes les décisions sont validées</li>
      <li>Génération du procès-verbal final (CE-1151)</li>
      <li>Envoi des courriers de décision</li>
    </ul>
  </li>
</ul>
</div>

<hr>

<h2>🎨 Éléments de design</h2>

<h3>Codes couleurs</h3>
<ul>
  <li><strong>Suspension</strong> : Badge jaune (#fff3cd / #856404)</li>
  <li><strong>Suppression</strong> : Badge rouge (#f8d7da / #721c24)</li>
  <li><strong>Proposition RU</strong> : Fond bleu clair (#e7f3ff) avec bordure bleue</li>
  <li><strong>Décision finale</strong> : Fond vert clair (#d4edda) avec bordure verte</li>
  <li><strong>Antécédents</strong> : Fond jaune clair (#fff3cd) avec bordure orange</li>
  <li><strong>Alerte âge</strong> : Badge jaune clignotant (#ffc107)</li>
  <li><strong>Validation directeur</strong> :
    <ul>
      <li>En attente : Jaune (#fff3cd)</li>
      <li>Accord : Vert (#d4edda)</li>
      <li>Sursoir : Rouge (#f8d7da)</li>
    </ul>
  </li>
</ul>

</div>
`;

export default readmeContent;
